<template>
    <div class="px-6 py-5 overflow-y-auto right-content-grid-vs h-[calc(100vh-309px)]">
        <div class="text-[#414141] font-sans">
            <h3 class="text-[1.25rem] leading-[1.75rem] mb-[1rem] font-semibold">
                Overview
            </h3>
            <p class="text-[14px] leading-[22px] mb-[0.5rem]">A gift pyramid is a tool that helps an organization determine the number of donors, prospects, and gifts needed to raise a specific amount of money. A gift pyramid will also help an organization prioritize how it spends its time cultivating and soliciting donors. Donors/gifts at the top of the pyramid will be larger in size, but only a few of them will be needed. The higher-level donors/gifts should also fund a majority of your organization's fundraising goal. Donors/gifts at the bottom of the pyramid will be smaller, but more donors will be needed.</p>
        </div>
    </div>
</template>

<script setup>
import { inject, onMounted } from 'vue';
import { useStepValidation } from '@/composables/useStepValidation';
const addToaster = inject('addToaster');

onMounted(() => {
  if (addToaster) {
    addToaster({
      title: 'Well done!',
      resourceName: 'Case for support',
      resourceLink: '#'
    });
    addToaster({
      title: 'Well done!',
      resourceName: 'Case for Support Narrative',
      resourceLink: '#'
    });
  }
});

// Use the validation composable with default settings
useStepValidation();
</script>

<style scoped>
</style> 